// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"ddd16f8a","138":"e2e89617","270":"dd666a81","387":"4d61303c","404":"7dae82bf","488":"b2a64b34","545":"c5156129","686":"ee27509b","706":"44ba4c26","728":"f150d78a","801":"ac6b6b43","888":"360e6758"}[chunkId] + ".chunk.js";
};